import React from "react";
import Header from "../../components/header";
import { Link } from "react-router-dom";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true
};

const Home = () => (
  <div>
    <Header />
    {/* banner part start*/}
    <section className="banner_part">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7 col-xl-6">
            <div className="banner_text">
              <div className="banner_text_iner">
                <h1>
                  Mansarovar Urban <br /> Cooperative Bank Ltd.
                </h1>
                <AnchorLink className="btn_1" href="#learn_more">
                  learn more
                </AnchorLink>
                <a
                  style={{ marginLeft: 5 }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn_1"
                  href="https://webmail1.hostinger.in/?_task=mail&_mbox=INBOX"
                >
                  employee login
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-xl-6 ">
            <Slider {...settings}>
              <div>
                <img
                  src="/img/banner_bg.jpg"
                  style={{ width: 550, height: 550 }}
                  alt="bank_img"
                />
              </div>
              <div>
                <img
                  src="/img/atm-bank.jpeg"
                  style={{ width: 550, height: 550 }}
                  alt="bank_img"
                />
              </div>
              <div>
                <img
                  src="/img/loans-bank.png"
                  style={{ width: 550, height: 550 }}
                  alt="bank_img"
                />
              </div>
              <div>
                <img
                  src="/img/education-bank.jpg"
                  style={{ width: 550, height: 550 }}
                  alt="bank_img"
                />
              </div>
              <div>
                <img
                  src="/img/car-loan.jpg"
                  style={{ width: 550, height: 550 }}
                  alt="bank_img"
                />
              </div>
              <div>
                <img
                  src="/img/housing-loan.jpg"
                  style={{ width: 550, height: 550 }}
                  alt="bank_img"
                />
              </div>
            </Slider>
          </div>
        </div>
      </div>
      <div className="hero-app-1 custom-animation">
        <img src="img/animate_icon/icon_1.png" alt="" />
      </div>
      <div className="hero-app-2 custom-animation2">
        <img src="img/animate_icon/icon_2.png" alt="" />
      </div>
      <div className="hero-app-5 custom-animation4">
        <img src="img/animate_icon/icon_5.png" alt="" />
      </div>
      <div className="hero-app-7 custom-animation2">
        <img src="img/animate_icon/icon_7.png" alt="" />
      </div>
      <div className="hero-app-8 custom-animation">
        <img src="img/animate_icon/icon_8.png" alt="" />
      </div>
    </section>
    {/* banner part start*/}
    {/* about part start*/}
    <section className="about_part" id="learn_more">
      <div className="container">
        <div className="row align-items-center justify-content-end">
          <div className="col-md-6 col-lg-6 col-xl-5">
            <div className="about_img">
              <img src="img/about_img_1.png" alt="" />
            </div>
          </div>
          <div className="col-md-6 col-lg-6 offset-xl-1 col-xl-6">
            <div className="about_text">
              <h2>We Have 34 Year Expereince in banking</h2>
              <h4>Know about the bank</h4>
              <p>
                Mansarovar Urban Cooperative Bank Ltd, was established in the
                year 1986 under U.P. Cooperative societies Act 1965...
              </p>
              <Link to="/about" className="btn_2">
                read more
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-app-7 custom-animation">
        <img src="img/animate_icon/icon_1.png" alt="" />
      </div>
      <div className="hero-app-8 custom-animation2">
        <img src="img/animate_icon/icon_2.png" alt="" />
      </div>
      <div className="hero-app-6 custom-animation3">
        <img src="img/animate_icon/icon_3.png" alt="" />
      </div>
    </section>
    {/* about part start*/}
    {/* service_part start*/}
    <section className="service_part section_padding gray_bg">
      <div className="container">
        <div className="row">
          <div
            className="col-sm-12 col-lg-12 col-xl-12"
            style={{ textAlign: "center" }}
          >
            <div className="single_service_text">
              <h2>We Provide Best Services</h2>
              <p>
                Committed to serving customers with the highest standards of
                professionalism and excellence, offering a wide range of
                services.
              </p>
              {/* <a href="#" className="btn_2">
                Load More
              </a> */}
            </div>
          </div>
          <div className="col-sm-6 col-xl-4" style={{ marginTop: 10 }}>
            <div className="single_service_part">
              <span className="single_service_icon">
                <i className="flaticon-growth" />
              </span>
              <h4>Services</h4>
              <ul style={{ listStyle: "disc" }}>
                <li style={{ fontSize: 18 }}>RTGS | NEFT</li>
                <li style={{ fontSize: 18 }}>ATM cum Debit Card(RuPay)</li>
                <li style={{ fontSize: 18 }}>ATM</li>
                <li style={{ fontSize: 18 }}>SMS alert</li>
                <li style={{ fontSize: 18 }}>E-commerce | POS payment</li>
                <li style={{ fontSize: 18 }}>Safe deposit lockers</li>
                <li style={{ fontSize: 18 }}>CTS | NACH | ACH</li>
                <li style={{ fontSize: 18 }}>Direct Benefit Transfer</li>
                <li style={{ fontSize: 18 }}>Personal Cheque Book</li>
              </ul>
              {/* <a href="#" className="btn_3">
                Learn More <i className="ti-arrow-right" />
              </a> */}
            </div>
          </div>
          <div className="col-sm-6 col-xl-4" style={{ marginTop: 10 }}>
            <div className="single_service_part single_service_part_2">
              <span className="single_service_icon style_icon">
                <i className="flaticon-wallet" />
              </span>
              <h4>Credit Facilities</h4>
              <ul style={{ listStyle: "disc" }}>
                <li style={{ fontSize: 18 }}>Housing Loan</li>
                <li style={{ fontSize: 18 }}>Vehicle Loan</li>
                <li style={{ fontSize: 18 }}>Commercial Vehicle Loan</li>
                <li style={{ fontSize: 18 }}>
                  Loan to professionals and self-employed
                </li>
                <li style={{ fontSize: 18 }}>Loan to MSME</li>
                <li style={{ fontSize: 18 }}>Loan against property</li>
                <li style={{ fontSize: 18 }}>Education loan</li>
              </ul>
              <br />
            </div>
          </div>
          <div className="col-sm-6 col-xl-4" style={{ marginTop: 10 }}>
            <div className="single_service_part single_service_part_2">
              <span className="single_service_icon style_icon">
                <i className="flaticon-wallet" />
              </span>
              <h4>Deposit Schemes</h4>
              <ul style={{ listStyle: "disc" }}>
                <li style={{ fontSize: 18 }}>Term Deposit</li>
                <li style={{ fontSize: 18 }}>Recurring Deposit</li>
                <li style={{ fontSize: 18 }}>Savings Bank Deposit</li>
                <li style={{ fontSize: 18 }}>Current Account</li>
                <li style={{ fontSize: 18 }}>Daily Deposit</li>
              </ul>
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="footer-area section_padding">
      <div className="container">
        <div className="row">
          <div
            className="col-sm-12 col-lg-12 col-xl-12"
            style={{ textAlign: "center" }}
          >
            <div className="single_service_text">
              <h2>Address</h2>
              <h4>
                Head Office:{" "}
                <span style={{ color: "#ff7e5f" }}>
                  A-969, Indira Nagar Lucknow, 226016
                </span>
              </h4>
              <h4>
                Indiranagar Branch:{" "}
                <span style={{ color: "#ff7e5f" }}>
                  A-969, Indiranagar Lucknow, 226016
                </span>
              </h4>
              <h4>
                Transport Nagar Branch:{" "}
                <span style={{ color: "#ff7e5f" }}>
                  S-58/10, First Floor, Transport Nagar, Kanpur Road, Lucknow,
                  226012
                </span>
              </h4>
              {/* <a href="#" className="btn_2">
                Load More
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer className="copyright_part">
      <div className="container">
        <div className="row align-items-center">
          <p className="footer-text m-0 col-lg-8 col-md-12">
            {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
            Copyright MUCB © All rights reserved 2020 | Made with{" "}
            <i className="ti-heart" aria-hidden="true" /> by{" "}
            <a href="https://colorlib.com" target="_blank">
              Colorlib
            </a>{" "}
            in{" "}
            <a
              style={{ color: "#61dafb" }}
              href="https://reactjs.org"
              target="_blank"
            >
              React
            </a>
            {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
          </p>
        </div>
      </div>
    </footer>
  </div>
);

export default Home;
